<template>
	<div>
		<div class="h-container">
			<Commonheader/>
			<div class="h-wrap">
				<leftMenu/>
				<div class="h-main">
					<!-- <div class="fixedBox">
						<div class="fixed" v-for="(item,index) in imgslist" :key="index">
							<img :src="item.imgurl" alt="">
							<div class="tanBox" @click="adds(index)"><span style="margin-left:30px;">{{item.title}}</span></div>
						</div>
					</div>
					<demandadd :visible.sync="imgflag1" v-if="imgflag1" @imgfalse2="imgflag1=false" />
					<projectadd :visible.sync="imgflag2" v-if="imgflag2" @imgfalse4="imgflag2=false" />
					<dingdadd :visible.sync="imgflag3" v-if="imgflag3" @imgfalse3="imgflag3=false" />
					<contractadd :visible.sync="imgflag4" v-if="imgflag4" @imgfalse1="imgflag4=false" /> -->
<!--					<div class="fixedBox" @click="tabs">
						<img :src="imgurl" alt="">
					</div>
					<operation :visible.sync="imgflag" v-if="imgflag" @imgfalse1="imgflag=false" />-->
					<router-view />
					<Commonfooter />
				</div>
			</div>
		</div>
		
	</div>
</template>
<script>
	import imgurl from '../assets/images/ljj_operation.png'

	export default {
			name:"Home",
			data(){
				return{
					imgurl: imgurl,
					imgflag: false
				}
			},
			computed:{
		    
		    },
		    props:{
			  
			},
			mounted(){
				
			},
			created() {
			},
			methods:{
				tabs(){
					this.imgflag = true;
				}
			}
		}
</script>
<style scoped lang="scss">
	// @keyframes imgsmove{
	// 	from{
	// 		right: -52px;
	// 	}
	// 	to{
	// 		right: 0;
	// 	}
	// }
	.fixedBox{
		width: 0.8rem;
		height: 0.8rem;
		border-radius: 50%;
		position: fixed;
		bottom: 0.2rem;
		right: 0.1rem;
		z-index: 996;
		cursor: pointer;
		img{
			width: 100%;
			height: 100%;
			position: relative;
			z-index: 999;
		}
	}
</style>
